import { render } from "./RegionIcon.vue?vue&type=template&id=1a9ee3fb"
const script = {}

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__